import { render } from "./PatientAccountabilityOverview.vue?vue&type=template&id=4d5ed921&scoped=true"
import script from "./PatientAccountabilityOverview.vue?vue&type=script&lang=js"
export * from "./PatientAccountabilityOverview.vue?vue&type=script&lang=js"

import "./PatientAccountabilityOverview.vue?vue&type=style&index=0&id=4d5ed921&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5ed921"]])

export default __exports__